var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _vm.detailForm.stinvLink
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.stinvUrl },
                    },
                    [_vm._v("STINV链接")]
                  )
                : _vm._e(),
              _vm.closeBtn
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QUALITY_DEFECT_CLOSE,
                          expression: "QUALITY_DEFECT_CLOSE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.closeQualityDefect },
                    },
                    [_vm._v("结案")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "within_box" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "form_box" },
              [
                _c(
                  "el-form",
                  {
                    ref: "detailForm",
                    attrs: {
                      model: _vm.detailForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "主动报废编号",
                                  prop: "sroCode",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.sroCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "sroCode", $$v)
                                    },
                                    expression: "detailForm.sroCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "报废启动日期",
                                  prop: "startDate",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    disabled: "",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.startDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "startDate", $$v)
                                    },
                                    expression: "detailForm.startDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "报废项目简介",
                                  prop: "projectSummary",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.projectSummary,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "projectSummary",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.projectSummary",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "已结案", prop: "isClosed" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.isClosed,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "isClosed",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.isClosed",
                                    },
                                  },
                                  _vm._l(
                                    _vm.isClosedLists,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "SR等级", prop: "grade" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.grade,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.detailForm, "grade", $$v)
                                      },
                                      expression: "detailForm.grade",
                                    },
                                  },
                                  _vm._l(
                                    _vm.srGradeLists,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发起人", prop: "creator" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.creator,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "creator", $$v)
                                    },
                                    expression: "detailForm.creator",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态", prop: "status" } },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: "",
                                    table: "TT_QUALITY_DEFECT",
                                    field: "STATUS",
                                  },
                                  model: {
                                    value: _vm.detailForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "status", $$v)
                                    },
                                    expression: "detailForm.status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "原因", prop: "reason" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: "",
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.reason,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "reason", $$v)
                                    },
                                    expression: "detailForm.reason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "备注", prop: "remarks" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: "",
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.remarks,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "remarks", $$v)
                                    },
                                    expression: "detailForm.remarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "是否下发成功",
                                  prop: "isIssued",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.isIssued,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "isIssued", $$v)
                                    },
                                    expression: "detailForm.isIssued",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "下发时间", prop: "issueDate" },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.issueDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "issueDate", $$v)
                                    },
                                    expression: "detailForm.issueDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "tab_box" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      staticClass: "setLength",
                      attrs: { label: "产品明细", name: "tab1" },
                    },
                    [
                      _c(
                        "ux-grid",
                        {
                          ref: "plxTable1",
                          attrs: {
                            data: _vm.tabData1,
                            "keep-source": "",
                            "max-height": "500",
                            "show-overflow": "tooltip",
                            "highlight-current-row": "",
                          },
                          on: { "selection-change": _vm.selectionChange },
                        },
                        [
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "序号",
                              type: "index",
                              width: "60",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "产品编号",
                              field: "eightBitCode",
                              "min-width": "100",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "产品名称",
                              field: "eightBitCodeName",
                              "min-width": "100",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "结算单位名称",
                              field: "supplierName",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "Facility名称",
                              field: "facilityName",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "包装类型",
                              field: "packType",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.packType,
                                            "TT_QUALITY_DEFECT",
                                            "PACK_TYPE"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "生产日期",
                              field: "madeDate",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "批次号",
                              field: "batchNo",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "DCs",
                              field: "dcCode",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", { staticClass: "newDcs" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dcsFilter")(
                                              scope.row.dcCode
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "Markets",
                              field: "marketName",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", { staticClass: "newDcs" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dcsFilter")(
                                              scope.row.marketName
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "报废范围",
                              field: "disposalScope",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.disposalScope,
                                            "TT_QUALITY_DEFECT",
                                            "DISPOSAL_SCOPE"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "餐厅报废数量(箱)",
                              field: "storeDisposalQty",
                              "min-width": "150",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "DC报废数量(箱)",
                              field: "dcDisposalQty",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "报废数量(箱)",
                              field: "disposalQty",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "处理结果",
                              field: "handlingResult",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.handlingResult,
                                            "TT_QUALITY_DEFECT",
                                            "HANDLING_RESULT"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "门店报废统计", name: "tab2" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "plxTable1",
                          attrs: {
                            data: _vm.tabData2,
                            "keep-source": "",
                            "max-height": "500",
                            "show-overflow": "tooltip",
                            "highlight-current-row": "",
                          },
                          on: { "selection-change": _vm.selectionChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              type: "checkbox",
                              width: "80",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "序号",
                              type: "index",
                              width: "60",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "产品编号",
                              prop: "eightBitCode",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "产品名称",
                              prop: "eightBitCodeName",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "生产日期",
                              prop: "madeDate",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "批次号",
                              prop: "batchNo",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "DC",
                              prop: "dcCode",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "涉及Markets",
                              prop: "marketName",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "报废数量(箱)",
                              prop: "disposalQty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "附件上传", name: "tab3" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "plxTable2",
                          attrs: {
                            data: _vm.tabData3,
                            "max-height": "500",
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "附件名称",
                              prop: "documentName",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDownload(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.documentName))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "附件描述",
                              prop: "docComments",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "上传人",
                              prop: "userName",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "上传时间",
                              prop: "createDate",
                              "show-overflow-tooltip": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "操作日志", name: "tab4" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "plxTable3",
                          attrs: {
                            data: _vm.tabData4,
                            "max-height": "500",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作时间",
                              prop: "createDate",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作人",
                              prop: "operatorName",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作描述",
                              prop: "action",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "产品名称选择",
            visible: _vm.dialogProVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogProVisible = $event
            },
            close: _vm.onClosePro,
          },
        },
        [_c("selProDialog", { on: { setSelPro: _vm.setSelPro } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title_box" }, [
      _c("p", { staticClass: "line" }),
      _c("p", { staticClass: "title" }, [_vm._v("Case Detail")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }